module.exports = __webpack_public_path__ + "img/arrow_down.ee9a9db3.svg";